@if (isGroupRow) {
<span class="fw-600">{{ prefix }}: {{ entityName }} &nbsp;|&nbsp; Projects: {{ projectsCount }} &nbsp;|&nbsp; Selected: {{ selectedCount }}</span>
} @else if (isEmptyRow) {
<span class="text-muted fst-italic">No Projects configured</span>
} @else {
<span>{{ projectName }}</span>
}